import styled from "styled-components";
import TextAreaAutoresize from "react-textarea-autosize";

export const TextArea = styled(TextAreaAutoresize)`
  align-items: center;
  background: transparent;
  border: none;
  box-sizing: border-box;
  color: inherit;
  display: inline-flex;
  font-family: inherit;
  font-size: inherit;
  justify-content: center;
  line-height: inherit;
  margin: 0;
  outline: 0;
  padding: 0;
  resize: none;
  vertical-align: top;
`;
